var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWire = function SvgWire(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2,0,0,2,0,0)"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}")), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.969,11.9h1.5a1.5,1.5,0,0,1,1.5,1.5v8a1.5,1.5,0,0,1-1.5,1.5h-4a1.5,1.5,0,0,1-1.5-1.5v-5"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.969,
    y1: 20.396,
    x2: 22.969,
    y2: 20.396
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M13.673,11.99a2.221,2.221,0,0,0,1.858.875c1.139,0,2.063-.693,2.063-1.547s-.924-1.547-2.063-1.547-2.062-.693-2.062-1.548.924-1.547,2.062-1.547a2.221,2.221,0,0,1,1.858.875"
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.531,
    y1: 12.865,
    x2: 15.531,
    y2: 13.896
  }), /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.531,
    y1: 5.646,
    x2: 15.531,
    y2: 6.676
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M10.969,21.941h-2a3,3,0,0,1-3-3v-3"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "a",
    points: "3.969 17.941 5.969 15.941 7.969 17.941"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.244,10.076l4.284,2.5a1.222,1.222,0,0,0,1.838-1.056V5.883A2.447,2.447,0,0,0,7.153,3.771L2.87,1.273A1.223,1.223,0,0,0,1.031,2.329V7.965A2.444,2.444,0,0,0,2.244,10.076Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.254,1.1h8.355a1.255,1.255,0,0,1,1.285,1.223V4.511"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 5.594,
    cy: 7.802,
    r: 0.375
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWire);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "wire.3219c55b406db403b5ed65a2d6dfd464.svg";